import Immutable from 'immutable';

const routes = Immutable.Map({
    'HOME': '/',
	'INTRO': '/intro',
	'GAME': '/game'
});
export default routes;
